var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-container",attrs:{"id":"deal-map"}},[_c('client-only',[_c('l-map',{staticStyle:{"height":"100%","width":"100%"},attrs:{"options":{
        zoomControl: true,
        scrollWheelZoom: false,
        touchZoom: false,
        dragging: false,
      },"zoom-controls":false,"zoom":_vm.zoom,"center":_vm.location,"bounds":_vm.bounds},on:{"update:center":_vm.centerUpdated,"update:zoom":_vm.zoomUpdated,"update:bounds":_vm.boundsUpdated}},[_c('l-tile-layer',{attrs:{"url":_vm.mapUrl}}),_vm._v(" "),_vm._l((_vm.locations),function(position){return _c('l-marker',{key:`location-${position.lat}-${position.lng}`,attrs:{"lat-lng":position,"icon":_vm.mapIcon}})})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }